module.exports = __webpack_public_path__ + "img/logoAfflexWhite.3c9971d5.png";